<template>
  <asc-dialog
    :text="title"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="1000"
  >
    <asc-spinner-wrapper :loading="loading">
      <asc-fault-msg-code-grid
        :grid-columns="gridColumns"
        :values="faultMessages"
        :on-open-raw-report="onOpenRawReport"
        :on-visualize="onVisualize"
      ></asc-fault-msg-code-grid>
    </asc-spinner-wrapper>
  </asc-dialog>
</template>

<script>
import { AscFaultMsgDetailsMixin, AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscFaultMsgCodeGrid from '@/components/molecules/AscFaultMsgCodeGrid'

export default {
  name: 'AscFaultMsgDetailsDialog',

  components: {
    AscDialog,
    AscFaultMsgCodeGrid,
    AscSpinnerWrapper,
  },

  mixins: [AscFaultMsgDetailsMixin, AscDialogMixin],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
